import React from "react";
import styled from "styled-components";
import { ArrowRight, Headphones, MonitorSmartphone, Network, Target } from "lucide-react";

const Section = styled.section`
  background: #f6faff;
  padding: 0 0 18px;
`;

const Card = styled.div`
  max-width: 1360px;
  margin: 0 auto;
  padding: 24px 22px;
  border: 1px solid #dce5f6;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 48px rgba(20, 58, 130, 0.05);
`;

const Title = styled.h2`
  color: #071544;
  font-size: 1.7rem;
  line-height: 1.18;
  font-weight: 920;
  text-align: center;
  margin: 0 0 18px;
  letter-spacing: 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)) 150px;
  gap: 22px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const Reason = styled.div`
  min-height: 145px;
  padding: 18px;
  border: 1px solid #dce5f6;
  border-radius: 12px;
  background: #ffffff;

  .icon {
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    color: #0b55e8;
    margin-bottom: 12px;
  }

  h3 {
    color: #071544;
    font-size: 0.94rem;
    font-weight: 920;
    letter-spacing: 0;
    margin: 0 0 8px;
  }

  p {
    color: #4f5d82;
    font-size: 0.76rem;
    line-height: 1.45;
    margin: 0 0 12px;
  }

  a {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: #0b55e8;
    text-decoration: none;
    font-size: 0.76rem;
    font-weight: 900;
  }
`;

const Metric = styled.div`
  min-height: 145px;
  display: grid;
  place-items: center;
  text-align: center;
  padding: 18px;
  border-radius: 12px;
  background: #061a4d;
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);

  strong {
    display: block;
    color: #ffffff;
    font-size: 3rem;
    line-height: 0.95;
    font-weight: 920;
  }

  span {
    display: block;
    margin-top: 8px;
    color: #ffffff;
    font-size: 0.88rem;
    font-weight: 900;
  }

  p {
    margin: 8px 0 0;
    color: #bfd2ff;
    font-size: 0.72rem;
    line-height: 1.35;
  }
`;

const reasons = [
  {
    icon: Network,
    title: "Connected ecosystem",
    copy: "Products that integrate seamlessly to eliminate silos and streamline your business."
  },
  {
    icon: MonitorSmartphone,
    title: "Modern UI",
    copy: "Clean, intuitive and responsive interfaces designed for real productivity."
  },
  {
    icon: Headphones,
    title: "Dedicated support",
    copy: "Real people. Real support. We are with you at every step of your journey."
  },
  {
    icon: Target,
    title: "Business-focused solutions",
    copy: "Built with deep understanding of real-world business needs across industries."
  }
];

const Aboutus = () => {
  return (
    <Section id="company">
      <Card>
        <Title>Why companies choose Willovate</Title>
        <Grid>
          {reasons.map((reason) => {
            const Icon = reason.icon;
            return (
              <Reason key={reason.title}>
                <span className="icon"><Icon size={38} strokeWidth={1.6} /></span>
                <h3>{reason.title}</h3>
                <p>{reason.copy}</p>
                <a href="/products">Learn more <ArrowRight size={13} /></a>
              </Reason>
            );
          })}
          <Metric>
            <div>
              <strong>6+</strong>
              <span>Products</span>
              <p>One unified platform. Endless possibilities.</p>
            </div>
          </Metric>
        </Grid>
      </Card>
    </Section>
  );
};

export default Aboutus;
